import {from, of, zip} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import ChildApi from 'web-app/api/child-api';
import EmployeeApi from 'web-app/api/employee-api';
import ChildrenEntity from 'web-app/react/entities/children';
import EmployeesEntity from 'web-app/react/entities/employees';

import * as Actions from './actions';

const fetchAll = action$ =>
    action$.ofType(Actions.fetchAll.type).mergeMap(({payload}) => {
        const {fetchProps} = payload;

        /**
         * Added bangs and cast zip argument to any because I did a simple conversion from .js to .ts and didn't want to touch this code.
         */
        return zip(ChildrenEntity.observables.fetchAll!(fetchProps), EmployeesEntity.observables.fetchAll!(fetchProps))
            .flatMap(([childActions, employeeActions]: any) => {
                // Last action is the actual entity action.
                // This makes sure it's compatible if any of the entities has a entityReferences
                const childIds = childActions[childActions.length - 1].payload.response.map(child => child.id).toSet();
                const employeeIds = employeeActions[employeeActions.length - 1].payload.response
                    .map(employee => employee.id)
                    .toSet();
                return childActions
                    .concat(employeeActions)
                    .concat([Actions.fetchAllSuccess.action(childIds, employeeIds)]);
            })
            .catch(e => of(Actions.fetchAllFailed.action(e)));
    });

const checkinPeople = action$ =>
    action$.ofType(Actions.checkin.type).mergeMap(({payload}) => {
        const {childrenIds, employeesIds, groupId} = payload;

        const childrenObservables = childrenIds.map(childId =>
            from(ChildApi.checkin(childId, null, null, null, groupId)),
        );
        const employeesObservable = employeesIds.map(employeeId =>
            from(EmployeeApi.checkin(employeeId, groupId, undefined, undefined)),
        );

        return zip(...childrenObservables, ...employeesObservable)
            .map(() => Actions.checkinSuccess.action(childrenIds, employeesIds))
            .catch(e => of(Actions.checkinFailed.action(e, childrenIds, employeesIds)));
    });

const checkoutPeople = action$ =>
    action$.ofType(Actions.checkout.type).mergeMap(({payload}) => {
        const {childrenIds, employeesIds} = payload;

        const childrenObservables = childrenIds.map(childId => from(ChildApi.checkout(childId)));
        const employeesObservable = employeesIds.map(employeeId => from(EmployeeApi.checkout(employeeId)));

        return zip(...childrenObservables, ...employeesObservable)
            .map(() => Actions.checkoutSuccess.action(childrenIds, employeesIds))
            .catch(e => of(Actions.checkoutFailed.action(e, childrenIds, employeesIds)));
    });

export default combineEpics(fetchAll, checkinPeople, checkoutPeople);
